import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Grid, Container } from '@mui/material';
import Metatags from '../components/MetaTags/MetaTags';
import useStyles from '../hooks/useStyles';
import styles from '../layouts/pages/style';
import { PackageHeader } from '../components/CustomHeading';
import Versions from '../sections/Versions';
import { getEditions } from '../features';
import { useEditions } from '../sections/Versions/useEditions';
import usePackageSelection from '../modules/Accounts/components/PackageSelection/usePackageSelection';
import useToggle from '../hooks/useToggle';

function VersionsPage() {
  const dispatch = useDispatch();
  const { packageList } = usePackageSelection();
  const [refreshOrgEdBreakdown, setRefreshOrgEdBreakdown] = useToggle();

  useEffect(() => {
    dispatch(getEditions());
  }, [refreshOrgEdBreakdown]);

  const { editions } = useEditions();
  const location = useLocation();
  const more = location.state && location.state.more;
  const classes = useStyles(styles)();

  return (
    <>
      <Metatags metaTagName="Versions | ISV Insights" />
      <Container maxWidth="xl">
        <Grid container gap={2}>
          <Grid item xs={12} className={classes.cardStyles}>
            <PackageHeader noPackage heading="Versions" />
          </Grid>
          <Versions
            more={more}
            editions={editions}
            packageList={packageList}
            setRefreshOrgEdBreakdown={setRefreshOrgEdBreakdown}
          />
        </Grid>
      </Container>
    </>
  );
}

export default VersionsPage;
